var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChatAvatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_icon",
    "data-name": "Group icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4608",
    "data-name": "Group 4608",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1558",
    "data-name": "Rectangle 1558",
    width: 24,
    height: 24,
    fill: "#ffe4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4610",
    "data-name": "Group 4610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4609",
    "data-name": "Group 4609",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1560",
    "data-name": "Rectangle 1560",
    width: 22,
    height: 22,
    transform: "translate(1 1)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M6.658,17.351c-.009.009-.005.009-.005.018l0-.018Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M2.859,4.807a5.469,5.469,0,0,0-.927,3.236,5.652,5.652,0,0,0,1.281,3.479",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M4.738,3.02a4.974,4.974,0,0,1,2.729-.77,5.1,5.1,0,0,1,3.512,1.131A6.209,6.209,0,0,1,13.1,6.71",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M2.859,4.807S1.587,2.054,1.9,2.077c.251.019,2.889.955,2.874.956",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M2.9,19.644a5.469,5.469,0,0,1-.927-3.236,5.654,5.654,0,0,1,11.3-.267,5.746,5.746,0,0,1-1.494,4.266A5.722,5.722,0,0,1,7.507,22.2a4.972,4.972,0,0,1-2.729-.77",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M2.9,19.644s-1.272,2.753-.958,2.73c.251-.019,2.889-.955,2.874-.956",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M10.724,11.522l.21-1.158A5.715,5.715,0,0,1,16.221,5.85a5.955,5.955,0,0,1,2.91.684,5.151,5.151,0,0,1,1.987,1.739,6.2,6.2,0,0,1,1,3.507A5,5,0,0,1,21.28,14.5",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M19.453,16.338a5.418,5.418,0,0,1-3.248.849,5.6,5.6,0,0,1-2.49-.709",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M19.453,16.338s2.711,1.345,2.7,1.029c-.012-.252-.879-2.921-.881-2.907",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatAvatorIcon);
export default __webpack_public_path__ + "static/media/group-chat-avator-icon.074dd0ecedaebcd9f62b6ef58dac9ba1.svg";
export { ForwardRef as ReactComponent };